import inView from 'in-view';

export default {
	_videos: [],
	init() {
		this._videos = document.querySelectorAll('video');
		if (!this._videos.length) {
			return;
		}
		Array.prototype.forEach.call(this._videos, video => {
			video.pause();
		});
		inView('video').on('enter', video => {
			video.play();
		}).on('exit', video => {
			video.pause();
		});
	},
	reload()
	{
		this.init();
	}
}